import { NotifyHelper } from "../../../helpers/toast";
import { eSetTieuChuanActionTypeDefine } from "../../action-types/set-tieu-chuan/ISetTieuChuanActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const setTieuChuanActions = {
    ...generateActions(eSetTieuChuanActionTypeDefine, "SET_TIEU_CHUAN"),
    ...generateActionForKey(eSetTieuChuanActionTypeDefine, "SET_TIEU_CHUAN", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eSetTieuChuanActionTypeDefine, "SET_TIEU_CHUAN", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eSetTieuChuanActionTypeDefine, "SET_TIEU_CHUAN", "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eSetTieuChuanActionTypeDefine, "SET_TIEU_CHUAN", "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }),
}